<div class="container m-b-20 space-top layout-row layout-row gap-20px">
  <div #cobCatchUpStatus>
    <h2 class="no-m">
      {{ 'labels.heading.COB Catch-Up is' | translate }}:<span class="m-l-20 m-r-20">{{
        isCatchUpRunning ? ('labels.catalogs.Running' | translate) : ('labels.catalogs.Inactive' | translate)
      }}</span>
    </h2>
  </div>
  @if (!isCatchUpRunning) {
    <button mat-raised-button class="activate" (click)="runCatchUp()">
      <fa-icon icon="times-circle" class="m-r-10"></fa-icon>
      {{ 'labels.buttons.Run Catch-Up' | translate }}
    </button>
  }
</div>

<div class="container space-top">
  <LOSx-loan-locked></LOSx-loan-locked>
</div>
